const manifest = require('../../../../localization/manifest.json');

const ensureArray = (value) => (Array.isArray(value) ? value : []);

const buildCountryConfig = () => {
  const countries = Array.isArray(manifest?.countries)
    ? manifest.countries
    : [];

  const countryOrder = ensureArray(manifest?.countryOrder);

  const countriesBySlug = {};

  countries.forEach((entry) => {
    if (!entry || !entry.marketingSlug) {
      return;
    }
    const slug = String(entry.marketingSlug).toLowerCase();
    const currency = entry.currency || {};
    countriesBySlug[slug] = {
      language: entry.language,
      currency: {
        code: currency.code,
        locale: currency.locale,
        symbol: currency.symbol,
      },
      localeHints: ensureArray(entry.localeHints),
      countryCode: entry.code,
    };
  });

  const firstOrderedSlug = countryOrder
    .map(
      (code) => countries.find((entry) => entry.code === code)?.marketingSlug
    )
    .filter(Boolean)[0];

  const fallbackSlug =
    countries.find((entry) => entry?.marketingSlug)?.marketingSlug || 'gb';

  const defaultCountrySlug = (
    firstOrderedSlug ||
    fallbackSlug ||
    'gb'
  ).toLowerCase();

  return {
    defaultCountry: defaultCountrySlug,
    countries: countriesBySlug,
  };
};

const config = buildCountryConfig();

module.exports = config;
